import * as React from "react";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkText } from "uitk-react-text";
import { decorateEditorialHtml } from "../../../../ContentUtilities";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";

export const CitiHeaderSection = (props: { items: EditorialModel[] }) => {
  const { items } = props;
  if (items.length !== 2) {
    return null;
  }

  return (
    <UitkLayoutGrid space="two">
      <UitkText align="center" size={700} weight="bold">
        <div className="all-t-padding-twelve" dangerouslySetInnerHTML={decorateEditorialHtml(items[0].text)} />
      </UitkText>

      <UitkText align="center" size={300} weight="regular">
        <div className="all-b-padding-six" dangerouslySetInnerHTML={decorateEditorialHtml(items[1].text)} />
      </UitkText>
    </UitkLayoutGrid>
  );
};
export default CitiHeaderSection;
